import { HttpContextToken } from '@angular/common/http';

export const SKIP_BASE_URL = new HttpContextToken<boolean>(() => false);
export const SKIP_TIMEOUT = new HttpContextToken<boolean>(() => false);
export const SKIP_AUTH = new HttpContextToken<boolean>(() => false);
